export const APP_ENDPOINTS = {
    WEBSITES: '/websites',
    WEBSITE: '/website',
    COMPANIES: '/companies',
    COMPANY: '/company',
    TERMINALS: '/terminals',
    TERMINAL: '/terminal',
    ACCOUNTS: '/accounts',
    ACCOUNT: '/account',
    AUTH_LOGIN: '/auth/login',
    AUTH_LOGOUT: '/auth/logout',
    CURRENT_ACCOUNT: '/account/current',
    DOCUMENTS: '/documents',
    DOCUMENT: '/document',
    PLACES: '/places',
    PLACE: '/place',
    PRODUCTS: '/products',
    PRODUCT: '/product',
    COMPANY_OWNERS: '/company-owners',
    COMPANY_OWNER: '/company-owner',
    PRODUCT_CATEGORIES: '/product-categories',
    PRODUCT_CATEGORY: '/product-category',
    ORDERS: '/orders',
    ORDER: '/order',
    END_USERS: '/end-users',
    END_USER: '/end-user',
    CITIES: '/cities',
    NESTED_PRODUCTS: '/nested-products',
    NESTED_PRODUCT: '/nested-product',

    NESTED_PRODUCT_CATEGORIES: '/nested-product-categories',
    NESTED_PRODUCT_CATEGORY: '/nested-product-category',
    PROMOTIONS: '/promotions',
    PROMOTION: '/promotion',
};
